<template>
  <svg
    width="13"
    height="8"
    viewBox="0 0 13 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.91 0.296875L6.5 4.87687L11.09 0.296875L12.5 1.70687L6.5 7.70687L0.5 1.70687L1.91 0.296875Z"
      fill="#404A57"
    />
  </svg>
</template>

<script>
export default { name: "DrawerArrow" };
</script>

<style></style>
